import { allWatchers } from "./sagas";
import { SagaMiddleware } from "redux-saga";

export const initSagas = (sagaMiddleware: SagaMiddleware<Record<string, unknown>>) => {
    //this grabs all exported sagas watchers from within the sagas folder.  Ideally nothing else would be in this folder.
    allWatchers.forEach(sagaMiddleware.run.bind(sagaMiddleware));
};
